import _ from 'lodash';
import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import Reorder from 'react-reorder';
import Radium from 'radium';
import queryString from 'query-string';
import { push } from 'react-router-redux';
import { Drawer, DrawerContent, Button, Checkbox } from 'rmwc';

import * as defaultStyles from '../styles';
import Dialog from '../dialog/dialog';
import { request } from '../containers/actions';
import {
    setData, setBeginning, setSort, setTotalCount, setSearchTerm, toggleSelection,
    clearSelection, refresh, updateItem
} from './actions';
import Filters from './filters';
import Edit from './edit';
import { host_v2 } from '../utilities/requests';
import { removeItemSelection } from '../components/tree/actions';


class SortItem extends React.PureComponent {
    render() {
        return <div style={{ padding: '.25em .2em', cursor: '-webkit-grab' }}>
            <i
                style={{ cursor: 'pointer' }}
                className={`fa-${this.props.item.reversed ? 'sort-up' : 'sort-down'}`}
                onMouseDown={event => {
                    event.preventDefault();
                    this.props.item.onReverse();
                }}>
            </i> {this.props.item.label}
        </div>;

    }
}


//@Radium
class Item extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        pending: PropTypes.number,
    }

    constructor(props, context) {
        super(props, context);
        this.extractFields = this.extractFields.bind(this);
    }

    extractFields(field, counter) {
        const item = this.props.item.toJS();
        // variable content.
        let content;
        let persian = undefined;
        let mapping = undefined;
        if (_.isPlainObject(field)) {
            if (field.fields) {
                return _.concat(_.map(
                    _.isFunction(field.fields) ? field.fields(item) : field.fields,
                    field => this.extractFields(field, counter),
                ));
            }
            content = field.field;
            if (_.has(field, 'persian'))
                persian = field.persian;
            if (_.has(field, 'mapping'))
                mapping = field.mapping;
        }
        else
            content = field;
        if (_.isFunction(content))
            content = content(item);
        else {
            content = item[content];
            if ((persian || persian === undefined && !mapping) && (_.isString(content) || _.isNumber(content)))
                content = content.persian();
            if (mapping)
                content = _.find(
                    mapping,
                    i => i[1] === content,
                )[0];
        }
        if (content instanceof Array)
            return _.concat(_.map(content, field => this.extractFields(field, counter)));
        if (_.isBoolean(content)) {
            content = <div
                style={{
                    backgroundColor: content
                        ? defaultStyles.successBackColor
                        : defaultStyles.warningBackColor,
                    color: content
                        ? defaultStyles.successColor
                        : defaultStyles.warningColor,
                    borderColor: content
                        ? defaultStyles.successBorderColor
                        : defaultStyles.warningBorderColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '2em',
                    width: '2.5em',
                    margin: 'auto',
                }}
                className={content ? 'fa-check' : 'fa-times'}>
            </div>;
        }
        counter[0]++;
        return <td
            ref={((column, element) => this.props.refCallback(column, element)).bind(undefined, counter[0] - 1)}
            key={counter[0] - 1}
            style={{
                ...this.props.styles.items.itemsList.td,
                ...(field.style ? _.isFunction(field.style) ? field.style(item) : field.style : {}),
                backgroundColor: Radium.getState(this.state, 'row', ':hover')
                    ? '#eeeeee'
                    : this.props.store.get('selected').has(item.id) ? '#f5f5f5' : 'white',
            }}>
            {field?.field === "gender" ? (item.gender == 1 ? "مرد" : (item.gender == 2 ? "زن" : "-")) : content}
        </td>;

        // this is in the the after content . or when every body say thing in this part . fall of in the after object and any content.
    }
    render() {
        const item = this.props.item.toJS();
        let counter = [0];
        if (this.props.itemComponent) {
            const Component = this.props.itemComponent;
            return <div
                key={this.props.id}
                style={{
                    ...this.props.styles.items.itemsList.item,
                    width: this.props.itemWidth
                        ? typeof this.props.itemWidth === 'number' ? `${this.props.itemWidth}px` : this.props.itemWidth
                        : undefined,
                }}>
                <Component
                    data={item}
                    selected={this.props.store.get('selected').has(item.id)}
                />
            </div>;
        }
        else {
            return <tr
                title={this.props.tooltip
                    ? _.isFunction(this.props.tooltip) ? this.props.tooltip(item) : item[this.props.tooltip]
                    : null
                }
                key='row'
                style={{
                    cursor: this.props.readonly ? 'default' : 'pointer',
                    backgroundColor: this.props.store.get('selected').has(item.id) ? '#f5f5f5' : 'white',
                    transform: 'translateZ(0)',
                    ':hover': {
                        backgroundColor: '#eeeeee',
                    },
                }}
                onClick={() => {
                    if (!this.props.readonly)
                        this.context.store.dispatch(push(this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + `${item.id}/`));
                }}
                {..._.mapValues(this.props.events, eventHandler => event => eventHandler(item, event))}>
                {this.props.selectable
                    ? <td
                        ref={element => this.props.refCallback('', element)}
                        style={{
                            ...this.props.styles.items.itemsList.td,
                            width: '1em',
                            backgroundColor: Radium.getState(this.state, 'row', ':hover')
                                ? '#eeeeee'
                                : this.props.store.get('selected').has(item.id) ? '#f5f5f5' : 'white',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.context.store.dispatch(toggleSelection(
                                item,
                                this.props.store.get('elementId'),
                            ));
                        }}>
                        <div className='mdc-checkbox'>
                            <input
                                type='checkbox'
                                className='mdc-checkbox__native-control'
                                checked={this.props.store.get('selected').has(item.id)}
                                onChange={() => { }}
                                onFocus={({ target }) => target.blur()}
                            />
                            <div className='mdc-checkbox__background'>
                                <svg className='mdc-checkbox__checkmark'
                                    viewBox='0 0 24 24'>
                                    <path className='mdc-checkbox__checkmark__path'
                                        fill='none'
                                        stroke='white'
                                        d='M1.73,12.91 8.1,19.28 22.79,4.59'
                                    />
                                </svg>
                                <div className='mdc-checkbox__mixedmark'></div>
                            </div>
                        </div>
                    </td>
                    : null
                }
                {_.concat(_.map(this.props.listFields, field => this.extractFields(field, counter)))}
            </tr>;
        }
    }
}


//@Radium
export default class PaginatedContainer extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        pending: PropTypes.number,
    }

    static defaultProps = {
        sidebar: true,
        filters: [],
        sorts: [],
        actions: [],
        buttonActions: [],
        booleanProperties: [],
        itemWidth: 320,
        style: {},
        fixedColumns: 0,
        pageSize: 8,
    };

    fixedElements = [];

    state = {
        filters: {},
        pageSize: this.props.pageSize,
        page: Math.floor(this.props.store.get('beginning') / this.props.pageSize) + 1,
        openFilters: true,
        openSorts: false,
        error: false,
    }

    constructor(props) {
        super(props);
        this.fetching = 0;
        this.fetch = this.fetch.bind(this);
        this.applySort = this.applySort.bind(this);
        this.setPositions = this.setPositions.bind(this);
        this.checkBooleanProperty = this.checkBooleanProperty.bind(this);
        this.refCallbacks = _.map(new Array(1000), (__, index) => this.refCallback.bind(this, index));
        // this.pFilterTable = this.pFilterTable.bind(this); 
    }

    componentDidCatch(error, info) {
        console.error(error, info);
        this.setState({ error: true });
    }

    componentWillMount() {
        this.styles = _.merge(_.cloneDeep(_styles), this.props.style);
    }

componentDidMount() {
    this.mounted = true;

    if (this.props.sorts) {
        this.context.store.dispatch([
            setSearchTerm('', this.props.store.get('elementId')),
            setSort(this.props.sorts, this.props.store.get('elementId')),
        ]);
    }

    try {
        const saved = localStorage.getItem(`filters_${this.props.store.get('elementId')}`);
        if (saved) {
            let parsed = JSON.parse(saved);

      
            const filters = parsed.map(f => {
                let selected = f.selected;

                if (typeof selected === 'string') {
                    try {
                        const maybeObj = JSON.parse(selected);
                        if (typeof maybeObj === 'object' && maybeObj !== null) {
                            selected = maybeObj;
                        }
                    } catch {
                        
                    }
                }

                return {
                    ...f,
                    selected,
                };
            });

            console.log("✅ Loaded filters from localStorage:", filters);

            
            this.setState({ filters }, () => {
                this.fetch({ ...this.props, filters }, this.state);
            });

            return;
        }
    } catch (err) {
        console.warn('Error loading filters from localStorage:', err);
    }

    this.fetch(this.props, this.state);
}


    componentWillUnmount() {
        this.mounted = false;
    }
    GotoUrl(item="exam") {
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        if(item=="book"){
            var url = host_v2 + "/ExportExcel/StoreBook?authToken=" + auth;
        }else{
            var url = host_v2 + "/ExportExcel/StoreExam?authToken=" + auth;
        }
        window.open(url, '_blank');
    }
   componentWillUpdate(nextProps, nextState) {
  if (this.props.style !== nextProps.style)
    this.styles = _.merge(_.cloneDeep(_styles), nextProps.style);

  if (this.props.sorts !== nextProps.sorts)
    this.context.store.dispatch(setSort(nextProps.sorts, this.props.store.get('elementId')));

  const filtersChanged = !_.isEqual(
    _.map(_.filter(nextProps.filters, f => f.field), f => [f.selected, f.value, f.field]),
    _.map(_.filter(this.props.filters, f => f.field), f => [f.selected, f.value, f.field])
  );

  if (
    nextProps.store.get('beginning') !== this.props.store.get('beginning') ||
    nextProps.store.get('sorts') !== this.props.store.get('sorts') ||
    nextProps.store.get('searchTerm') !== this.props.store.get('searchTerm') ||
    nextState.pageSize !== this.state.pageSize ||
    nextState.showSelected !== this.state.showSelected ||
    filtersChanged
  ) {
    
    if (filtersChanged && nextProps.filters) {
      try {
        const safeFilters = nextProps.filters.map(f => ({
          field: f.field,
          selected:
            f.selected && typeof f.selected === 'object'
              ? JSON.stringify(f.selected)
              : f.selected ?? null,
        }));
        localStorage.setItem(
          `filters_${this.props.store.get('elementId')}`,
          JSON.stringify(safeFilters)
        );
      } catch (err) {
        console.warn('Error saving filters:', err);
      }
    }

    this.fetch(nextProps, nextState, {
      resetBeginning: nextProps.store.get('beginning') === this.props.store.get('beginning'),
    });
  }

  if (nextProps.store.get('searchTerm') !== this.props.store.get('searchTerm')) {
    this.setState({ searchTerm: nextProps.store.get('searchTerm') });
  }

  if (nextProps.store.get('selected') !== this.props.store.get('selected')) {
    const states = nextProps.store.get('data').map(item =>
      nextProps.store.get('selected').has(item.get('id'))
    );
    this.refs.selectAll.indeterminate = states.some(_.identity) && !states.every(_.identity);
  }

  if (nextProps.store.get('data') !== this.props.store.get('data'))
    this.setState({ error: false });
}



    // pFilterTable(){ 
    //     this.fetch(this.props, this.state, {resetBeginning: this.props.store.get('beginning') === this.props.store.get('beginning')});
    // }
    setPositions() {
        //These parameters distroyed examination-execution page, so I removed this function from onScroll 
        _.forEach(this.fixedElements, element => {
            element.style.transform = `translateX(-${this.refs.tableContainer.scrollWidth -
                this.refs.tableContainer.clientWidth -
                this.refs.tableContainer.scrollLeft
                }px) translateZ(1px)`;
        });
        this.refs.tableHead.style.transform = `translateY(${this.refs.tableContainer.scrollTop}px) translateZ(2px)`;
    }

    applySort(__, ___, ____, _____, sort) {
        this.context.store.dispatch(setSort(sort, this.props.store.get('elementId')));
    }

    async fetch(props, state, { resetBeginning } = { resetBeginning: true }) {
        let data = [];
        let count = 0;
        this.fetchIdCounter = this.fetchIdCounter || 0;
        const fetchId = ++this.fetchIdCounter;
        if (props != undefined && props.store != undefined) this.context.store.dispatch([
            setData([], props.store.get('elementId')),
            setTotalCount(0, props.store.get('elementId')),
            ...(resetBeginning || !props.store.get('beginning') ? [setBeginning(0, props.store.get('elementId'))] : []),
        ]);


        if (
            props == undefined ||
            props.store == undefined ||
            props.store.get('beginning') === undefined ||
            props.store.get('beginning') === null
        )
            return;
        try {
            const url = `/${props.resource}/?` + queryString.stringify({
                offset: resetBeginning ? 0 : props.store.get('beginning'),
                limit: state.pageSize,
                ..._.mapValues(
                    _.mapKeys(_.filter(props.filters, f => f.field), f => f.field),
                    f => state.showSelected ? '' : f.value || _.map(f.selected, (_, value) => value).join(','),
                ),
                search: (props.store.get('searchTerm') || '').split(' ').join(','),
                id: state.showSelected ? props.store.get('selected').keySeq().join(',') : '',
                o: props.store.get('sorts').map(item => (item.get('reversed') ? '-' : '') + item.get('name')).toArray().join(','),
            });
            if (window.location.pathname === `/examinations/${window.location.pathname.split("/")[2]}/questions/`
                || window.location.pathname === `/examinations/${window.location.pathname.split("/")[2]}/layout/`
                || window.location.pathname === `/examinations/${window.location.pathname.split("/")[2]}/info/`) {
                if (props.resource !== "examination") {
                    this.fetching++;
                    // debugger;
                    const response = await this.context.store.dispatch(request(url));
                    this.fetching--;
                    if (response.onError) {

                    }
                    if (this.fetchIdCounter !== fetchId)
                        return;
                    count = response.count;
                    data = response.results;
                    if (!this.mounted)
                        return;
                    await this.context.store.dispatch([
                        setData(data, props.store.get('elementId')),
                        setTotalCount(count, props.store.get('elementId')),
                    ]);
                    this.setState({
                        page: Math.floor(props.store.get('beginning') / state.pageSize) + 1,
                    });
                }
            }
            else {
                this.fetching++;
                // debugger;
                const response = await this.context.store.dispatch(request(url));
                this.fetching--;
                if (response.onError) {

                }
                if (this.fetchIdCounter !== fetchId)
                    return;
                count = response.count;
                data = response.results;
                if (!this.mounted)
                    return;
                await this.context.store.dispatch([
                    setData(data, props.store.get('elementId')),
                    setTotalCount(count, props.store.get('elementId')),
                ]);
                this.setState({
                    page: Math.floor(props.store.get('beginning') / state.pageSize) + 1,
                });
            }
        }
        catch (exception) {
            this.fetching--;
            alert("مشکلی پیش آمده است لطفا دوباره امتحان کنید.");
            console.error(exception);
        }
    }

    refCallback(index, column, element) {
        if (column !== '' && column >= this.props.fixedColumns)
            return;
        if (element) {
            this.fixedElements.push(element);
        }
        else {
            this.fixedElements.splice(this.fixedElements.indexOf(this['item-' + column + '-' + index]), 1);
        }
        this['item-' + column + '-' + index] = element;
    }

    extractHeaders(descriptor) {
        const labels = _.map(
            descriptor,
            item => ({ ..._.isPlainObject(item) ? item : { label: item }, ...this.extractHeaders(item.labels) }),
        );
        return {
            labels,
            height: (_.maxBy(labels, 'height') || { height: 0 }).height + 1,
            width: _.sumBy(labels, 'width') || 1,
        };
    }

    renderHeaders(descriptor, row, styles, columnBase = 0, height = undefined) {
        if (height === undefined)
            height = descriptor.height;
        if (row > 0) {
            let columns = 0;
            return _.concat.apply(undefined, _.map(
                descriptor.labels,
                descriptor => {
                    columns += descriptor.width;
                    return this.renderHeaders(descriptor, row - 1, styles, columns + columnBase - descriptor.width, height - 1);
                },
            ));
        }
        let columns = 0;
        const sort = this.props.store.get('sorts').toJS();
        return _.map(descriptor.labels, descriptor => {
            let label = descriptor;
            if (_.isPlainObject(descriptor))
                label = descriptor.label;
            columns += descriptor.width;
            return <th
                ref={((columns, element) => {
                    if (columns + columnBase - descriptor.width >= this.props.fixedColumns)
                        return;
                    if (element) {
                        this.fixedElements.push(element);
                    }
                    else {
                        this.fixedElements.splice(
                            this.fixedElements.indexOf(this['item-' + (columns + columnBase - descriptor.width) + '-' + String(-row - 1)]),
                            1,
                        );
                    }
                    this['item-' + (columns + columnBase - descriptor.width) + '-' + String(-row - 1)] = element;
                }).bind(undefined, columns)}
                key={columns + columnBase - descriptor.width}
                colSpan={descriptor.width}
                rowSpan={height - descriptor.height}
                style={{
                    ...styles.items.itemsList.th,
                    whiteSpace: 'pre',
                    backgroundColor: 'white',
                    textAlign: descriptor.labels.length ? 'center' : 'right',
                    cursor: descriptor.sort ? 'pointer' : styles.items.itemsList.th.cursor,
                }}
                onClick={() => {
                    if (!descriptor.sort)
                        return;
                    const sort = this.props.store.get('sorts').toJS();
                    const itemIndex = sort.findIndex(item => item.name === descriptor.sort);
                    const item = sort[itemIndex];
                    if (itemIndex === 0)
                        sort.splice(0, 1, { ...item, reversed: !item.reversed });
                    else {
                        sort.splice(sort.findIndex(item => item.name === descriptor.sort), 1);
                        sort.splice(0, 0, item);
                    }
                    this.context.store.dispatch([
                        setBeginning(0, this.props.store.get('elementId')),
                        setSort(sort, this.props.store.get('elementId')),
                    ]);
                }}>
                {label}
                &nbsp;
                {sort[0] && sort[0].name === descriptor.sort
                    ? <i className={`fa-${sort[0].reversed ? 'sort-up' : 'sort-down'}`} />
                    : null
                }
            </th>;
        });
    }

    checkBooleanProperty(property, item) {
        return property.inverse ^ _.find(
            property.mapping || [[true, true], [false, false]],
            i => i[1] === item.get(property.field)
        )[0];
    }

    render() {
        window.counter2 = window.counter2 || 0;
        window.counter2++;
        const headers = this.extractHeaders(this.props.listFields);
        const styles = this.styles;
        const items = this.state.error ? ['-'] : this.fetching > 0 ? [] : this.props.store.get('data').map((item, index) => <Item
            key={index}
            store={this.props.store}
            item={item}
            styles={styles}
            listFields={this.props.listFields}
            tooltip={this.props.tooltip}
            readonly={this.props.readonly}
            selectable={this.props.selectable}
            events={this.props.events}
            itemWidth={this.props.itemWidth}
            refCallback={this.refCallbacks[index]}
        />).toArray();
        return <div style={styles.main}>
            {this.props.editDialog
                ? <Dialog
                    easyCancel={false}
                    isOpen={this.props.active}>
                    <Edit
                        store={this.props.store.get('edit')}
                        resource={this.props.resource}
                        id={this.props.active}
                        refresh={this.fetch}
                        {...this.props.editProps}
                    />
                    <span>
                        {(this.props.active === 'add' ? window.gettext('Add') : window.gettext('Edit')) + ' ' + this.props.title}
                    </span>
                </Dialog>
                : <div style={{ display: this.props.active ? undefined : 'none' }}>
                    <Edit
                        store={this.props.store.get('edit')}
                        resource={this.props.resource}
                        id={this.props.active}
                        refresh={this.fetch}
                        {...this.props.editProps}
                    />
                </div>
            }
            <div
                style={{
                    display: this.props.active && !this.props.editDialog ? 'none' : 'flex',
                    height: '100%',
                }}>
                <Radium.Style
                    rules={{
                        '.mdc-drawer--persistent>nav.mdc-drawer__drawer': {
                            overflow: 'unset',
                        },
                        'div.mdc-simple-menu__items.mdc-list': {
                            padding: '0',
                        },
                        '.mdc-simple-menu__items': {
                            willChange: 'unset',
                            overflowY: 'hidden',
                        },
                    }}
                />
                <Drawer
                    persistent
                    style={{
                        ...styles.filters,
                        overflow: this.state.showFilters ? 'unset' : 'hidden',
                    }}
                    open={this.state.showFilters}
                    onClose={() => this.setState({ showFilters: false })}>
                    <DrawerContent>
                        <div
                            style={{ padding: '.75em 0', color: '#9a9a9a', fontWeight: '700' }}
                            onClick={() => this.setState({ openFilters: !this.state.openFilters })}>
                            <i className='fa-filter fa-lg'></i>
                            &nbsp;
                            {window.gettext('Filter')}
                            <i
                                style={{
                                    float: 'left',
                                    marginLeft: '1em',
                                    transform: this.state.openFilters ? 'rotateZ(-90deg)' : 'rotateZ(0)',
                                    transition: '300ms',
                                }}
                                className='fa-chevron-left'>
                            </i>
                        </div>
                        <button
                            style={{ ...defaultStyles.defaultButton, }}
                            onClick={() => {
                                let arr = [];
                                _.map(this.props.filters, item => {
                                    if (item.component) {
                                        _.map(Object.keys(item.selected), (selectedId) => {
                                            console.log(selectedId)
                                            arr.push({ field: item.field, id: selectedId, uuid: item?.component?.props?.children?.props?.store?.toJS().elementId })
                                        })
                                    }
                                })
                                _.map(arr, item => {
                                    this.context.store.dispatch(
                                        removeItemSelection(item.id, item.field, item.uuid))
                                })

                            }}
                        >حدف تمامی فیلتر ها</button>
                        <div style={{ clear: "both" }}></div>
                        {/* {console.log(this.props.filters[4].component.props.children.props.store.toJS())} */}
                        {this.state.openFilters
                            ? <Filters filters={this.props.filters} />
                            : null
                        }
                        {/* <div>
                            <button style={{...defaultStyles.defaultButton,margin : "4px"}} onClick={this.pFilterTable}>اعمال فیلتر</button>
                        </div> */}
                        <hr className='mdc-list-divider' />
                        <div
                            style={{ padding: '.75em 0', color: '#9a9a9a', fontWeight: '700' }}
                            onClick={() => this.setState({ openSorts: !this.state.openSorts })}>
                            <i className='fa-sort-alpha-asc fa-lg'></i>
                            &nbsp;
                            {window.gettext('Sort')}
                            <i
                                style={{
                                    float: 'left',
                                    marginLeft: '1em',
                                    transform: this.state.openSorts ? 'rotateZ(-90deg)' : 'rotateZ(0)',
                                    transition: '300ms',
                                }}
                                className='fa-chevron-left'>
                            </i>
                        </div>
                        {this.state.openSorts
                            ? <span style={{ userSelect: 'none' }}>
                                <Reorder
                                    itemKey='name'
                                    lock='horizontal'
                                    list={_.map(
                                        _.filter(this.props.store.get('sorts').toJS(), item => !item.hidden),
                                        item => ({
                                            ...item, onReverse: () => {
                                                const sort = this.props.store.get('sorts').toJS();
                                                sort.splice(
                                                    sort.findIndex(i => i.name === item.name),
                                                    1,
                                                    { ...item, reversed: !item.reversed },
                                                );
                                                this.context.store.dispatch([
                                                    setBeginning(0, this.props.store.get('elementId')),
                                                    setSort(sort, this.props.store.get('elementId')),
                                                ]);
                                            }
                                        }),
                                    )}
                                    template={SortItem}
                                    listClass='sort-items'
                                    itemClass='sort-item'
                                    callback={this.applySort}
                                />
                            </span>
                            : null
                        }
                    </DrawerContent>
                </Drawer>
                <div style={styles.items}>
                    <div style={styles.items.header}>
                        <div style={{ position: 'relative' }}>
                            <span style={styles.items.header.title}>
                                {this.props.title}
                            </span>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    textAlign: 'center',
                                    width: '35%',
                                    zIndex: 4,
                                }}>
                                {this.props.store.get('messages').map((message, index) => <div
                                    key={index}
                                    style={{
                                        backgroundColor: defaultStyles.successBackColor,
                                        color: defaultStyles.successColor,
                                        border: `.0625em solid ${defaultStyles.successColor}`,
                                        opacity: message.get('fade') ? '0' : '1',
                                        transition: 'opacity 3000ms',
                                    }}>
                                    {message.get('message')}
                                </div>).toArray()}
                            </div>
                        </div>
                        <div>
                            {this.props.sidebar
                                ? <button
                                    style={{
                                        ...defaultStyles.button,
                                        minWidth: undefined,
                                        float: 'right',
                                        width: '2.7em',
                                        height: '2.7em',
                                        marginLeft: '.5em',
                                        marginRight: '.5em',
                                    }}
                                    onClick={() => this.setState({ showFilters: !this.state.showFilters })}>
                                    <i className='fa-bars fa-lg'></i>
                                </button>
                                : null
                            }
                            {
                                this.props.resource === "admin-order" ?
                                [
                                    <button
                                        style={{
                                            ...defaultStyles.button,
                                            backgroundColor: 'rgb(0, 0, 155)',
                                            color: 'white',
                                            float: 'right',
                                            marginLeft: '.5em',
                                            marginRight: '.5em',
                                        }}
                                        onClick={() => this.GotoUrl("exam")}>
                                        خروجی اکسل آزمون ها
                                    </button>,
                                    <button
                                        style={{
                                            ...defaultStyles.button,
                                            backgroundColor: 'rgb(0, 0, 155)',
                                            color: 'white',
                                            float: 'right',
                                            marginLeft: '.5em',
                                            marginRight: '.5em',
                                        }}
                                        onClick={() => this.GotoUrl("book")}>
                                        خروجی اکسل کتاب ها
                                    </button>
                                ]
                                    : null
                            }

                            {this.props.pubreport ? null : <div style={styles.items.header.search}>
                                <input
                                    id='input-filters'
                                    // onClick={(e)=>}
                                    style={{
                                        ...defaultStyles.input,
                                        ...(this.context.pending
                                            ? {
                                                // color: 'transparent',
                                                textShadow: '0 0 0 black',
                                                outline: 'none',
                                            }
                                            : {}),
                                    }}
                                    placeholder={window.gettext('Search')}
                                    value={(this.state.searchTerm || '').persian()}
                                    onKeyDown={event => {
                                        if (this.context.pending) {
                                            event.preventDefault();
                                            return false;
                                        }
                                    }}
                                    onKeyPress={event => {
                                        if (this.context.pending) {
                                            event.preventDefault();
                                            return false;
                                        }
                                        else {
                                            if ((event.keyCode || event.charCode) == 13) {
                                                this.context.store.dispatch(setSearchTerm(
                                                    this.state.searchTerm,
                                                    this.props.store.get('elementId'),
                                                ));
                                            }
                                        }
                                    }
                                    }
                                    onChange={({ target: { value } }) => this.setState({ searchTerm: value.english() })}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: '.5em',
                                        top: '0',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                    <i
                                        style={{ marginLeft: '.25em' }}
                                        onClick={() => this.context.store.dispatch(setSearchTerm(
                                            this.state.searchTerm,
                                            this.props.store.get('elementId'),
                                        ))}
                                        className='fa-search fa-lg'>
                                    </i>
                                    <i
                                        onClick={() => {
                                            this.context.store.dispatch(setSearchTerm('', this.props.store.get('elementId')));
                                        }}
                                        className='fa-times fa-lg'>
                                    </i>
                                </div>
                            </div>}

                            <div style={styles.items.header.actions}>
                                {_.map(
                                    this.props.buttonActions,
                                    (action, index) => action.component
                                        ? <div
                                            key={index}
                                            style={{
                                                marginRight: '.5em',
                                                ...action.style,
                                            }}>
                                            {action.component}
                                        </div>
                                        : <button
                                            key={index}
                                            style={{
                                                ...(action.default ? defaultStyles.defaultButton : defaultStyles.button),
                                                marginRight: '.5em',
                                                ...action.style,
                                            }}
                                            onClick={action.action}>
                                            {action.label}
                                        </button>,
                                )}
                                {window.location.pathname.slice(1, window.location.pathname.length - 1) == "analyze-examinations" &&
                                    <button
                                        onClick={this.props.handleShowAnalyzePage}
                                        style={{
                                            ...defaultStyles.button,
                                            marginRight: '.5em',
                                        }}>
                                        مشاهده تحلیل ها
                                    </button>
                                }
                                {_.map(
                                    this.props.actions,
                                    (action, index) => action.component
                                        ? <div
                                            key={index}
                                            style={{
                                                marginRight: '.5em',
                                                ...action.style,
                                            }}>
                                            {action.component}
                                        </div>
                                        : <button
                                            key={index}
                                            style={{
                                                ...(action.default ? defaultStyles.defaultButton : defaultStyles.button),
                                                marginRight: '.5em',
                                                ...action.style,
                                            }}
                                            onClick={action.action}>
                                            {action.label}
                                        </button>,
                                )}
                                {this.props.store.get('selected').size > 0
                                    ? _.map(
                                        this.props.booleanProperties,
                                        (property, index) => <button
                                            key={index}
                                            style={{
                                                ..._.pickBy(defaultStyles.button, (__, key) => key !== 'padding'),
                                                marginRight: '.5em',
                                                paddingTop: '0',
                                                paddingBottom: '0',
                                                paddingLeft: '.5em',
                                                paddingRight: '0',
                                                ...property.style,
                                            }}
                                            onChange={async () => {
                                                const checked = !this.props.store.get('selected').every(
                                                    this.checkBooleanProperty.bind(null, property),
                                                );
                                                const value = _.find(
                                                    property.mapping || [[true, true], [false, false]],
                                                    i => i[0] === Boolean(property.inverse ^ checked),
                                                )[1];
                                                const response = await this.context.store.dispatch(request({
                                                    path: `/${this.props.resource}/`,
                                                    body: this.props.store.get('selected').map((__, id) => ({
                                                        id,
                                                        [property.field]: value,
                                                    })).toArray(),
                                                    method: 'PATCH',
                                                }));
                                                this.context.store.dispatch(_.map(
                                                    response,
                                                    item => updateItem(
                                                        item,
                                                        this.props.store.get('elementId'),
                                                    ),
                                                ));
                                            }}>
                                            <Checkbox
                                                key={index}
                                                style={{
                                                    marginRight: '.5em',
                                                    ...property.style,
                                                }}
                                                label={property.label || window.gettext(_.camelCase(property.field))}
                                                checked={this.props.store.get('selected').every(this.checkBooleanProperty.bind(null, property))}
                                                indeterminate={
                                                    this.props.store.get('selected').some(this.checkBooleanProperty.bind(null, property)) &&
                                                    !this.props.store.get('selected').every(this.checkBooleanProperty.bind(null, property))
                                                }
                                            />
                                        </button>,
                                    )
                                    : null
                                }
                            </div>
                        </div>
                        <hr style={{ clear: 'both' }} />
                        <div style={{ width: '100%' }}>
                            <div style={{ float: 'right' }}>
                                <div>
                                    <span id='beginning'>
                                        {(Math.min(this.props.store.get('beginning') + 1, this.props.store.get('totalCount'))).persian()}&nbsp;
                                    </span>
                                    {window.gettext('To')}
                                    <span id='end'>
                                        &nbsp;{(this.props.store.get('beginning') + this.props.store.get('data').size).persian()}&nbsp;
                                    </span>
                                    {window.gettext('From')}
                                    <span id='all'>
                                        &nbsp;{this.props.store.get('totalCount').persian()}
                                    </span>
                                    &nbsp;
                                    {this.props.store.get('sorts').size > 0
                                        ? <span style={styles.items.header.sortedBy}>
                                            (
                                            {this.props.store.get('sorts').getIn([0, 'hidden'])
                                                ? null
                                                : window.gettext('Sorted by') + ' ' + this.props.store.get('sorts').getIn([0, 'label'])
                                            }
                                            )
                                        </span>
                                        : null
                                    }
                                </div>
                            </div>
                            <div style={{ float: 'left', marginTop: '.25em' }}>
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        const iframe = document.createElement('iframe');
                                        iframe.style.width = '0';
                                        iframe.style.height = '0';
                                        iframe.style.border = 'none';
                                        iframe.srcdoc = `<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <link rel="stylesheet" type="text/css" href="/css/mathjax.css">
        <style>
            @page {
                size: A4 Portrait;
                margin: 0;
            }
            html, body {
                font-family: IRANSans;
                font-size: 11pt;
                margin: 0;
                width : 210mm;
                height : 297mm;
                size: auto;
                direction: rtl;
            }
            @media print {
                div {
                    -webkit-print-color-adjust: exact;
                }
            }
        </style>
    <script src="/mathjax/MathJax.js?delayStartupUntil=configured"></script>
    </head>
    <body onload='parent._printBodyLoaded()'>
        <span id='content'><span>1</span><span style='font-weight: 700;'>2</span></span>
        <script type='text/javascript'>
            MathJax.Hub.Config({
                config: ['MMLorHTML.js'],
                jax: ['input/TeX','input/MathML','input/AsciiMath','output/HTML-CSS','output/NativeMML', 'output/PreviewHTML'],
                extensions: ['tex2jax.js','mml2jax.js','asciimath2jax.js', 'fast-preview.js', 'AssistiveMML.js'],
                TeX: {
                    extensions: [
                        'AMSmath.js',
                        'AMSsymbols.js',
                        'AMScd.js',
                        'noErrors.js',
                        'noUndefined.js',
                        'cancel.js',
                        'mhchem.js',
                        'autobold.js',
                    ],
                },
                'HTML-CSS': {
                    mtextFontInherit: true,
                },
                messageStyle: 'none',
                menuSettings: {
                    inTabOrder: false,
                    context: 'Browser',
                },
                processSectionDelay: 0,
                skipStartupTypeset: true,
            });
            MathJax.Hub.Configured();
        </script>
    </body>
</html>`;
                                        window._printBodyLoaded = async () => {
                                            const printStyles = _.cloneDeep(styles);
                                            printStyles.items.itemsList.th.color = 'black';
                                            const win = iframe.contentWindow;
                                            const items = this.props.store.get('data').map((item, index) => <Item
                                                key={index}
                                                store={this.props.store}
                                                item={item}
                                                styles={printStyles}
                                                listFields={this.props.listFields}
                                                tooltip={false}
                                                readonly={true}
                                                selectable={false}
                                                itemWidth={this.props.itemWidth}
                                                refCallback={() => null}
                                            />).toArray();
                                            ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                            ReactDom.render(<table
                                                style={{
                                                    borderSpacing: '0',
                                                    width: '100%',
                                                    transformStyle: 'preserve-3d',
                                                    ...printStyles.items.itemsList.table,
                                                }}>
                                                <thead>
                                                    <tr>
                                                        {this.renderHeaders(headers, 0, printStyles)}
                                                    </tr>
                                                    {_.map(new Array(headers.height - 2), (__, row) => <tr key={row}>
                                                        {this.renderHeaders(headers, row + 1, printStyles)}
                                                    </tr>)}
                                                </thead>
                                                <tbody>
                                                    {items}
                                                </tbody>
                                            </table>, win.document.getElementById('content'));
                                            await window.wait();
                                            win.print();
                                            delete window._printBodyLoaded;
                                            iframe.remove();
                                        };
                                        document.body.appendChild(iframe);
                                    }}
                                    className='fa-print fa-lg'>
                                </i>
                                &nbsp;
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const tsv = _.map(
                                            this.refs.tableContainer.querySelectorAll('tr'),
                                            tr => _.map(tr.querySelectorAll('th,td'), td => td.innerText).join('\t'),
                                        ).join('\n');
                                        const blob = new Blob([tsv], { type: 'text/plain' });
                                        var downloadAnchor = document.createElement('a');
                                        downloadAnchor.setAttribute('href', window.URL.createObjectURL(blob));
                                        downloadAnchor.setAttribute('download', this.props.title);
                                        downloadAnchor.click();
                                    }}
                                    className='fa-table fa-lg'>
                                </i>
                                &nbsp;
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const keyword = this.props.resource
                                        Object.keys(localStorage).filter(el => {
                                            if (el.includes(keyword)) {
                                                localStorage.removeItem(el)
                                                return el;
                                            }
                                        });
                                        this.context.store.dispatch(refresh(this.props.store.get('elementId')))
                                    }}
                                    className='fa-refresh fa-lg'>
                                </i>
                                &nbsp;
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const pageSize = Number.parseInt(prompt(
                                            window.gettext('Enter number of items per page:'),
                                            this.state.pageSize,
                                        ));
                                        if (pageSize)
                                            this.setState({ pageSize });
                                    }}
                                    className='fa-cog fa-lg'>
                                </i>
                            </div>
                            {this.props.store.get('selected').size
                                ? <div
                                    style={{
                                        float: 'left',
                                        marginLeft: '.5em',
                                        fontSize: '.9em',
                                        backgroundColor: this.state.showSelected ? '#b5d9f0' : undefined,
                                    }}>
                                    <i
                                        style={{ cursor: 'pointer', margin: '.25em' }}
                                        onClick={() => {
                                            this.context.store.dispatch(clearSelection(this.props.store.get('elementId')));
                                            this.setState({ showSelected: false });
                                        }}
                                        className='fa-times fa-lg'>
                                    </i>
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={async () => {
                                            if (this.props.store.get('searchTerm'))
                                                this.context.store.dispatch(setSearchTerm('', this.props.store.get('elementId')));
                                            this.setState({ showSelected: !this.state.showSelected });
                                        }}>
                                        {window.interpolate(
                                            window.gettext('%(selected)s items selected'),
                                            { selected: this.props.store.get('selected').size.persian() },
                                            true,
                                        )}
                                    </span>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                    <div ref='tableContainer' style={styles.items.itemsList} /*onScroll={this.setPositions}*/>
                        {this.props.itemComponent
                            ? { items }
                            : <table
                                style={{
                                    borderSpacing: '0',
                                    width: '100%',
                                    transformStyle: 'preserve-3d',
                                    ...styles.items.itemsList.table,
                                }}>
                                <thead ref='tableHead'>
                                    <tr>
                                        {this.props.selectable
                                            ? <th
                                                ref={element => {
                                                    if (element) {
                                                        this.fixedElements.push(element);
                                                    }
                                                    else {
                                                        this.fixedElements.splice(this.fixedElements.indexOf(this['item--1--1']), 1);
                                                    }
                                                    this['item--1--1'] = element;
                                                }}
                                                rowSpan={headers.height - 1}
                                                style={{
                                                    ...styles.items.itemsList.th,
                                                    width: '1em',
                                                    backgroundColor: 'white',
                                                }}
                                                onClick={() => {
                                                    const clear = this.props.store.get('data').every(
                                                        item => this.props.store.get('selected').has(item.get('id')),
                                                    );
                                                    this.context.store.dispatch(_.map(
                                                        _.filter(
                                                            this.props.store.get('data').toJS(),
                                                            item => this.props.store.get('selected').has(item.id) ? clear : !clear,
                                                        ),
                                                        item => toggleSelection(item, this.props.store.get('elementId')),
                                                    ));
                                                }}>
                                                <div className='mdc-checkbox'>
                                                    <input
                                                        type='checkbox'
                                                        ref='selectAll'
                                                        className='mdc-checkbox__native-control'
                                                        checked={this.props.store.get('data').every(
                                                            item => this.props.store.get('selected').has(item.get('id')),
                                                        )}
                                                        onChange={() => { }}
                                                        onFocus={({ target }) => target.blur()}
                                                    />
                                                    <div className='mdc-checkbox__background'>
                                                        <svg className='mdc-checkbox__checkmark'
                                                            viewBox='0 0 24 24'>
                                                            <path className='mdc-checkbox__checkmark__path'
                                                                fill='none'
                                                                stroke='white'
                                                                d='M1.73,12.91 8.1,19.28 22.79,4.59'
                                                            />
                                                        </svg>
                                                        <div className='mdc-checkbox__mixedmark'></div>
                                                    </div>
                                                </div>
                                            </th>
                                            : null
                                        }
                                        {this.renderHeaders(headers, 0, styles)}
                                    </tr>
                                    {_.map(new Array(headers.height - 2), (__, row) => <tr key={row}>
                                        {this.renderHeaders(headers, row + 1, styles)}/
                                    </tr>)}
                                </thead>
                                <tbody>
                                    {items}
                                </tbody>
                            </table>
                        }
                    </div>
                    <i style={{ clear: 'both', display: 'block' }}></i>
                    {(
                        this.props.store.get('data').size > 0 &&
                        this.props.store.get('beginning') ||
                        this.props.store.get('beginning') + this.props.store.get('data').size < this.props.store.get('totalCount')
                    )
                        ? <div style={styles.items.navigation}>
                            <Button
                                style={{
                                    opacity: this.props.store.get('data').size > 0 && this.props.store.get('beginning') > 0 ? undefined : '0',
                                    pointerEvents: this.props.store.get('data').size > 0 && this.props.store.get('beginning') > 0
                                        ? undefined
                                        : 'none',
                                }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.context.store.dispatch(setBeginning(
                                        Math.max(this.props.store.get('beginning') - this.state.pageSize, 0),
                                        this.props.store.get('elementId'),
                                    ));
                                }}>
                                <i className='fa-chevron-right'></i>
                            </Button>
                            {this.props.store.get('totalCount') > this.state.pageSize
                                ? <span>
                                    <input
                                        type='text'
                                        key='locate'
                                        value={this.state.page.persian()}
                                        size={Math.max(String(this.state.page).length, 1)}
                                        style={styles.items.navigation.locate}
                                        onChange={event => {
                                            this.setState({ page: event.target.value.english() });
                                        }}
                                        onKeyPress={event => {
                                            if ((event.keyCode || event.charCode) == 13) {
                                                this.context.store.dispatch(setBeginning(
                                                    (this.state.page - 1) * this.state.pageSize,
                                                    this.props.store.get('elementId'),
                                                ));
                                            }
                                        }}
                                    />
                                    &nbsp;&nbsp;
                                    {window.gettext('From')} {Math.ceil(this.props.store.get('totalCount') / this.state.pageSize).persian()}
                                </span>
                                : <span>&nbsp;</span>
                            }
                            <Button
                                style={{
                                    opacity: this.props.store.get('beginning') + this.props.store.get('data').size <
                                        this.props.store.get('totalCount') ? undefined : '0',
                                    pointerEvents: this.props.store.get('beginning') + this.props.store.get('data').size <
                                        this.props.store.get('totalCount') ? undefined : 'none',
                                }}
                                onClick={event => {
                                    event.preventDefault();
                                    this.context.store.dispatch(setBeginning(
                                        this.props.store.get('beginning') + this.state.pageSize,
                                        this.props.store.get('elementId'),
                                    ));
                                }}>
                                <i className='fa-chevron-left'></i>
                            </Button>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>;
    }
}


const _styles = ({
    main: {
        position: 'relative',
        float: 'right',
        width: '100%',
        height: '100%',
        clear: 'both',
    },
    items: {
        flexGrow: '1',
        width: '0',
        marginRight: '.5em',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        header: {
            marginBottom: '.5em',
            title: {
                color: '#5e5e5e',
                fontSize: '1.6em',
            },
            sortedBy: {
                color: defaultStyles.secondaryColor,
                fontSize: '.85em',
            },
            search: {
                marginBottom: '.5em',
                position: 'relative',
                float: 'right',
                title: {
                    marginLeft: '.5em',
                },
                fa: {
                    fontSize: '1.1em',
                    marginRight: '.5em',
                },
            },
            actions: {
                float: 'left',
                display: 'flex',
                flexDirection: 'row-reverse',
                alignItems: 'center',
            },
        },
        itemsList: {
            overflowX: 'auto',
            clear: 'both',
            width: '100%',
            table: {
            },
            item: {
                float: 'right',
            },
            td: {
                verticalAlign: 'middle',
                lineHeight: '1.8em',
                borderBottom: '.0625em solid #eaeaea',
                fontSize: '.9em',
                whiteSpace: 'nowrap',
                textAlign: 'right',
                padding: '.3em',
                overflow: 'overlay',
                unicodeBidi: 'plaintext',
            },
            th: {
                verticalAlign: 'middle',
                lineHeight: '1.9em',
                borderTop: '.0625em solid #eaeaea',
                borderBottom: '.2em solid #eaeaea',
                color: '#7a7a7a',
                fontSize: '.8em',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                textAlign: 'right',
                padding: '.4em',
                unicodeBidi: 'plaintext',
            },
        },
        navigation: {
            textAlign: 'center',
            padding: '.5em',
            next: {
                float: 'right',
                color: '#55bb11',
                textAlign: 'left',
                width: '20%',
            },
            previous: {
                float: 'right',
                color: '#55bb11',
                textAlign: 'right',
                width: '20%',
            },
            locate: {
                ...defaultStyles.field,
                width: '3em',
                display: 'inline-block',
                textAlign: 'center',
                marginBottom: undefined,
            },
        },
    },
    filters: {
        zIndex: '8',
    },
});
